import produce from 'immer';

import { MarketStatus } from '@swf/generated/types/api/sports';
import type { MarketPollingData } from '@swf/sports/types/market';
import { notEmpty } from '@swf/sports/utils/notEmpty';
import updateMarket from '@swf/sports/utils/updateMarket';

import { defaultState } from './defaultState';
import type { LandingPageSuccessResponse } from './types';

type State = typeof defaultState;

export const reducers = {
  clear: (): State => produce(defaultState, (draft) => draft),
  landingPageRequested: (state: State): State => ({
    ...state,
    isLoading: true
  }),
  landingPageLoadSuccess: (state: State, payload: LandingPageSuccessResponse): State => ({
    ...state,
    ...payload,
    isLoading: false,
    hasPreloaded: true
  }),
  landingPageLoadFailure: (state: State): State => ({
    ...state,
    isLoading: false,
    hasPreloaded: true,
    error: true
  }),
  marketsUpdated: (state: State, { data: marketUpdates, closed }: MarketPollingData) =>
    produce(state, (draft) => {
      Object.entries(marketUpdates).forEach(([marketUpdateId, marketUpdate]) => {
        Object.values(draft.markets)
          .filter(notEmpty)
          .forEach((market) => {
            if (closed.includes(market.marketId)) {
              market.marketStatus = MarketStatus.CLOSED;
              return;
            }
            if (market.marketId === marketUpdateId && marketUpdate) {
              updateMarket(market, marketUpdate);
            }
          });
      });
      return draft;
    })
};
